module.exports = __webpack_public_path__ + "img/Sleeves-Front-Gd-Hb-Ib.9353fb1d.png";